import { __decorate } from "tslib";
import React, { Component } from 'react';
import ReactResizeObserver from '../../../lib/_util/resizeObserver';
import autobind from '../_util/autobind';
export default class ResizeObservedRow extends Component {
    handleResize(_width, height) {
        const { onResize, rowIndex } = this.props;
        onResize(rowIndex, height);
    }
    render() {
        const { children } = this.props;
        return (React.createElement(ReactResizeObserver, { resizeProp: "height", onResize: this.handleResize }, children));
    }
}
__decorate([
    autobind
], ResizeObservedRow.prototype, "handleResize", null);
